import script from "./newsConsultation.vue?vue&type=script&setup=true&lang=js"
export * from "./newsConsultation.vue?vue&type=script&setup=true&lang=js"

import "./newsConsultation.vue?vue&type=style&index=0&id=396b6848&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-396b6848"]])

export default __exports__